import React from "react";

const componentData = {
  co: {
    limit: 8700, // Norm: 10 mg/m3 (8-hour average), source: GIOŚ (Poland)
    healthEffects: [
      "Bóle i zawroty głowy",
      "Osłabienie i zmęczenie",
      "Zaburzenia koncentracji",
      "Nudności i wymioty",
      "Zaburzenia rytmu serca (arytmia)",
      "Utrata przytomności",
      "Uszkodzenie mózgu (przy długotrwałym narażeniu)",
      "Zgon (w skrajnych przypadkach, przy bardzo wysokich stężeniach)",
    ],
    bibliography: [
      {
        title: "GIOŚ - Informacje o tlenku węgla",
        url: "https://powietrze.gios.gov.pl/pjp/content/o-tlenku-wegla",
      },
      {
        title:
          "Ministerstwo Zdrowia - Zatrucie tlenkiem węgla",
        url: "https://www.gov.pl/web/zdrowie/zatrucie-tlenkiem-wegla-czadem", // (Ministry of Health - Carbon Monoxide Poisoning)
      },
    ],
  },
  no: {
    limit: 200, // Norm: 200 µg/m³ (1-hour average), source: GIOŚ (Poland)
    healthEffects: [
      "Podrażnienie błon śluzowych nosa i gardła",
      "Kaszel",
      "Uczucie duszności",
      "Zwiększona podatność na infekcje dróg oddechowych",
    ],
    bibliography: [
      {
        title: "WHO - Air quality guidelines for Europe, 2nd edition (NOx)",
        url: "https://www.euro.who.int/__data/assets/pdf_file/0005/78638/E90038.pdf", // Page 293
      },
    ],
  },
  no2: {
    limit: 90, // Norm: 40 µg/m³ (annual average), source: GIOŚ (Poland)
    healthEffects: [
      "Podrażnienie oczu, nosa i gardła",
      "Kaszel i świszczący oddech",
      "Zmniejszenie wydolności płuc",
      "Zaostrzenie objawów astmy",
      "Zwiększone ryzyko infekcji dróg oddechowych",
      "Możliwy wpływ na rozwój astmy u dzieci",
    ],
    bibliography: [
      {
        title:
          "WHO - Air quality guidelines for Europe, 2nd edition (NO2)",
        url: "https://www.euro.who.int/__data/assets/pdf_file/0005/78638/E90038.pdf", // Page 293
      },
    ],
  },
  o3: {
    limit: 100, // Norm: 120 µg/m³ (8-hour average), source: GIOŚ (Poland)
    healthEffects: [
      "Podrażnienie oczu, nosa i gardła",
      "Kaszel i ból w klatce piersiowej",
      "Trudności w oddychaniu",
      "Zmniejszenie wydolności płuc",
      "Zaostrzenie objawów astmy",
      "Zwiększone ryzyko infekcji dróg oddechowych",
      "Możliwe uszkodzenie tkanki płucnej",
    ],
    bibliography: [
      {
        title:
          "WHO - Air quality guidelines for Europe, 2nd edition (Ozone)",
        url: "https://www.euro.who.int/__data/assets/pdf_file/0006/78639/E90038.pdf", // Page 335
      },
    ],
  },
  so2: {
    limit: 200, // Norm: 125 µg/m³ (24-hour average), source: GIOŚ (Poland)
    healthEffects: [
      "Podrażnienie oczu, nosa i gardła",
      "Kaszel i duszność",
      "Zaostrzenie objawów astmy i przewlekłego zapalenia oskrzeli",
      "Zwiększone ryzyko infekcji dróg oddechowych",
      "Zmniejszenie wydolności płuc",
      "Podrażnienie skóry",
    ],
    bibliography: [
      {
        title:
          "WHO - Air quality guidelines for Europe, 2nd edition (SO2)",
        url: "https://www.euro.who.int/__data/assets/pdf_file/0007/78640/E90038.pdf", // Page 379
      },
    ],
  },
  pm2_5: {
    limit: 35, // Norm: 25 µg/m³ (annual average), source: GIOŚ (Poland)
    healthEffects: [
      "Podrażnienie oczu, nosa i gardła",
      "Kaszel i duszność",
      "Zmniejszenie wydolności płuc",
      "Zaostrzenie objawów astmy i chorób serca",
      "Zwiększone ryzyko zawału serca i udaru mózgu",
      "Nowotwory płuc",
      "Przedwczesna śmierć",
    ],
    bibliography: [
      {
        title: 'Wpływ na zdrowie PM2.5 - Polski Alarm Smogowy',
        url: 'https://polskialarmsmogowy.pl/zdrowie/wplyw-na-zdrowie-pm10-pm2-5-bap-wwa'
      },
      {
        title: "WHO - Ambient (outdoor) air pollution",
        url: "https://www.who.int/news-room/fact-sheets/detail/ambient-(outdoor)-air-quality-and-health",
      },
    ],
  },
  pm10: {
    limit: 70, // Norm: 50 µg/m³ (24-hour average), source: GIOŚ (Poland)
    healthEffects: [
      "Podrażnienie oczu, nosa i gardła",
      "Kaszel i duszność",
      "Zaostrzenie objawów astmy i przewlekłych chorób płuc",
      "Zwiększone ryzyko infekcji dróg oddechowych",
      "Zmniejszenie wydolności płuc",
      "Zwiększone ryzyko chorób sercowo-naczyniowych",
    ],
    bibliography: [
      {
        title: 'Wpływ na zdrowie PM10 - Polski Alarm Smogowy',
        url: 'https://polskialarmsmogowy.pl/zdrowie/wplyw-na-zdrowie-pm10-pm2-5-bap-wwa'
      },
      {
        title: "WHO - Ambient (outdoor) air pollution",
        url: "https://www.who.int/news-room/fact-sheets/detail/ambient-(outdoor)-air-quality-and-health",
      },
    ],
  },
  nh3: {
    limit: 200, // Brak normy dobowej w Polsce, wartość orientacyjna
    healthEffects: [
      "Podrażnienie oczu, nosa i gardła",
      "Łzawienie oczu",
      "Katar",
      "Kaszel",
      "Obrzęk płuc (przy narażeniu na wysokie stężenia)",
    ],
    bibliography: [
      {
        title: "IPCS INCHEM: AMMONIA",
        url: "http://www.inchem.org/documents/jecfa/jecmono/v05je74.htm",
      },
      {
        title: "Agencja Ochrony Środowiska USA (EPA): Amoniak (NH3)",
        url: "https://www.epa.gov/sites/production/files/2016-09/documents/ammonia.pdf", // Replace with a Polish equivalent if available
      },
    ],
  },
};

function HealthEffectsTable({ components }) {
  const aggregatedHealthEffects = () => {
    const effects = {};
    Object.entries(components).forEach(([component, value]) => {
      const data = componentData[component];
      if (data && value > data.limit) {
        data.healthEffects.forEach((effect) => {
          if (!effects[effect]) {
            effects[effect] = [];
          }
          effects[effect].push({ component, value, limit: data.limit });
        });
      }
    });
    return effects;
  };

  const effects = aggregatedHealthEffects();

  return (
    <div className="health-effects">
      <h2 className="health-effects-title" >Czego się spodziewać?</h2>
      <table className="health-effects-table">
        <thead>
          <tr>
            <th>Możliwe efekty</th>
            <th>Źródło</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(effects).map(([effect, sources]) => (
            <tr key={effect}>
              <td>{effect}</td>
              <td>
                <ul className="source-list">
                  {sources.map((source, index) => (
                    <li key={index}>
                      {source.component.toUpperCase()}: <b>{source.value}</b> {" "}(µg/m³)
                    </li>
                  ))}
                </ul>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Bibliography Section */}
      <h3>Bibliografia</h3>
      <ul>
        {Object.entries(components).map(([component, value]) => {
          const data = componentData[component];
          if (data && value > data.limit) {
            return data.bibliography.map((ref, index) => (
              <li key={`${component}-ref-${index}`}>
                <a href={ref.url} target="_blank" rel="noopener noreferrer">
                  {ref.title}
                </a>
              </li>
            ));
          }
          return null;
        })}
      </ul>
    </div>
  );
}

export default HealthEffectsTable;